import { Component, inject } from '@angular/core';
import { AuthService } from '../auth.service';

@Component({
  selector: 'bc-error-page-component',
  templateUrl: './error-page.component.html',
})
export class ErrorPageComponent {
  email = inject(AuthService).email;
}
